import styled from "styled-components";

export const ComingsoonWrapper = styled.div`
  color: #fff;
  width: 100%;
  background: url("assets/Comingsoon/back.png") no-repeat;
  background-size: 100% 100%;
  padding: 80px 0;
`;

export const ComingsoonContainer = styled.div`
  max-width: 1200px;
  width: 95%;
  display: flex;
  align-items: center;
  flex-direction: column;
  gap: 20px;
  justify-content: center;
  margin: 0 auto;
`;

export const Rows = styled.div`
  display: flex;
  height: 440px;
  gap: 20px;
  width: 100%;
  @media screen and (max-width: 730px) {
    flex-direction: column;
    height: auto;
  }
`;
export const CardContainer = styled.div<{ bg?: string; width?: string }>`
  position: relative;
  background: ${(props) =>
    props.bg
      ? `url('${props.bg}') no-repeat`
      : "linear-gradient(180deg, rgba(158, 218, 209, 0.1) 0%, rgba(61, 179, 162, 0.1) 100%)"};
  background-size: cover;
  background-position: center;
  /* padding: 30px 50px; */
  position: relative;
  border-radius: 12px;
  box-shadow: 3px 4px 4px rgba(6225, 29, 72, 0.25);
  /* height: 440px; */
  width: ${(props) => props.width};
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  transition: all 0.3s;
  &:hover {
    box-shadow: rgba(225, 29, 72, 0.25) 0px 10px 20px,
      rgba(225, 29, 72, 0.25) 0px 6px 6px;
  }
  @media screen and (max-width: 930px) {
    /* padding: 20px 30px; */
    height: auto;
  }
  @media screen and (max-width: 730px) {
    width: 97%;
    margin: auto;
  }
`;

export const BuildTitle = styled.div`
  background: linear-gradient(90deg, #3db3a2 2.46%, #9edad1 98.45%);
  -webkit-background-clip: text;
  font-style: normal;
  font-weight: 700;
  font-size: 24px;
  line-height: 32px;
  background-clip: text;
  max-width: 350px;
  margin-bottom: 30px;
  @media screen and (max-width: 930px) {
    /* font-size: 27px;
    line-height: 35px; */
  }
  @media screen and (max-width: 730px) {
    max-width: 100%;
  }
`;
export const BuildContent = styled.div`
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 20px;
  text-align: center;
`;
export const BuildBtn = styled.div`
  cursor: pointer;
  width: 200px;
  height: 41.38px;
  flex: none;
  order: 2;
  flex-grow: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e11d48;
  border-radius: 6px;
  color: #fff;
  background-color: #e11d48;
  font-style: normal;
  font-weight: 700;
  font-size: 18px;
  line-height: 170%;
  transition: all 0.3s;
  &:hover {
    color: #e11d48;
    border: 1px solid #e11d48;
    background-color: transparent;
  }
  @media screen and (max-width: 1130px) {
    max-width: 180px;
    width: 100%;
    height: 50px;
    font-size: 17px;
  }
  @media screen and (max-width: 930px) {
    margin-top: 20px;
  }
`;
export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  justify-content: center;
  gap: 14px;
`;

export const CardOverlay = styled.div`
  min-height: 300px;
  box-sizing: border-box;
  padding: 30px 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s;
  /* position: absolute; */
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.7);
  border-radius: 12px;
  @media screen and (max-width: 768px) {
    padding: 30px 30px;
  }
`;

export const CommingSoonLock = styled.div`
  position: absolute;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #00000080;
  backdrop-filter: blur(5px);
  border-radius: 12px;
  img {
    width: 60%;
  }
  /* @media screen and (max-width: 768px) {
    background-size: 80% 80%;
  } */
`;
